import React from 'react';
import styles from './index.module.scss';
import NewEnergyGenerationTrend from './components/NewEnergyGenerationTrend';
import BsaChargingAndDischarging from './components/BsaChargingAndDischarging';
import BeneficialData from './components/BeneficialData';

const RightBox = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.top}>
        {/* 新能源发电趋势 */}
        <NewEnergyGenerationTrend />
      </div>
      <div className={styles.center}>
        {/* 储能数据监测 */}
        <BsaChargingAndDischarging />
      </div>
      <div className={styles.bottom}>
        {/* 收益数据 */}
        <BeneficialData />
      </div>
    </div>
  );
};

export default RightBox;
